import { render, staticRenderFns } from "./postUser.vue?vue&type=template&id=4f86ae8c&"
import script from "./postUser.vue?vue&type=script&lang=js&"
export * from "./postUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports